import { useCurrentModule } from '../components';
import { AI_RECOMMENDED_FOR_NAME_TRANSLATION_KEY, AI_RECOMMENDED_FOR_SITE_TRANSLATION_KEY } from '../utils/consts';
import { useUpgradeRecommendedProduct } from './useUpgradeRecommendedProduct';
export const CYCLE_UP_SAVE_MORE_TRANSLATION_KEY = 'premium-purchase-plan.eclipse.ai-recommendation.cycle-longer-save-more';
export const useUpgradeRecommendationCopy = () => {
  var _offering$currentSubs;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    productId,
    productName,
    siteName,
    cycleId
  } = useUpgradeRecommendedProduct();
  const {
    data: offering
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const {
    data: product,
    isLoading: isProductLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId: productId ?? ''
  }, Boolean(productId));
  if (!productId) {
    return undefined;
  }
  const isCycleUp = Boolean(cycleId && (product == null ? void 0 : product.productFamilyId) && product.productFamilyId === (offering == null || (_offering$currentSubs = offering.currentSubscriptionInfo) == null ? void 0 : _offering$currentSubs.productFamilyId));
  const planName = productName ?? '';
  return {
    isCycleUp,
    isSettled: !isProductLoading,
    title: siteName ? t(AI_RECOMMENDED_FOR_NAME_TRANSLATION_KEY, {
      planName,
      siteName
    }) : t(AI_RECOMMENDED_FOR_SITE_TRANSLATION_KEY, {
      planName
    }),
    subtitle: isCycleUp ? t(CYCLE_UP_SAVE_MORE_TRANSLATION_KEY) : undefined
  };
};
//# sourceMappingURL=useUpgradeRecommendationCopy.js.map